import { ReactNode } from 'react'
import { InfoCircleOutlined } from '@ant-design/icons'

export interface PageHelperTextProps {
  children: ReactNode
  icon?: ReactNode
  className?: string
}

export function PageHelperText({ children, icon, className = '' }: PageHelperTextProps) {
  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      <span className="w-3.5 h-3.5 flex items-center justify-center text-black/45">
        {icon || <InfoCircleOutlined className="text-sm" />}
      </span>
      <span className="text-sm text-black/45 font-normal leading-[22px]">
        {children}
      </span>
    </div>
  )
}

export default PageHelperText
